module.exports = "/_next/static/images/hero-image-06b41c90473b1d668f6c62e43ea69ee4.png.webp";